import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function Unauthorized() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: { xs: 4, sm: 6 } }}>
      <Paper sx={{ p: { xs: 3, sm: 4 }, maxWidth: 480, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom fontWeight={800} color="error.main">
          Access denied
        </Typography>
        <Typography variant="body1" color="text.secondary">
          You do not have permission to view this page.
        </Typography>
      </Paper>
    </Box>
  );
}
